import React, { useState, useCallback } from 'react';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import banner from  '../../Images/img.png';
import { selectDeleteUserDetails, selectLoading } from './Selectors';
import { Content } from 'antd/es/layout/layout';
import CustomSpin from '../CommonSpin';
import { useNavigate } from 'react-router-dom';
import { deleteUserRequest } from './Actions';
import './style.css';
import { BodyTextHeadingSmall, ButtonText, HeaderText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { TextArea } = Input;

const DeleteAccount = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [form] = Form.useForm();

    const [err, setErr] = useState(false);
    const requesting = useSelector(selectLoading);
    const successAccount = useSelector(selectDeleteUserDetails);

    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        feedback: '',
    });

    const [fieldError, setFieldError] = useState({
        fieldFirstName: false,
        fieldPhone: false,
        fieldEmail: false,
    });

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    if(successAccount) {
        navigate('/email-verification');
    }

    const handleSubmit = useCallback(() => {
        const { firstName, phoneNumber, email } = formValues;
        const updatedFieldError = {
            fieldFirstName: !firstName,
            fieldPhone: !phoneNumber,
            fieldEmail: !email,
        };
        setFieldError(updatedFieldError);

        if (firstName && phoneNumber && email) {
            dispatch(deleteUserRequest(formValues));
            // dispatch({ type: REQUEST_DELETE_USER, payload: formValues });
            form.resetFields();
            setFormValues({
                firstName: '',
                lastName: '',
                phoneNumber: '',
                email: '',
                feedback: '',
            });
            setErr(false);
        } else {
            setErr(true);
        }
    }, [formValues, dispatch, form]);

    const validateAlpha = (_, value) =>
        value && /^[a-zA-Z ]*$/.test(value)
            ? Promise.resolve()
            : Promise.reject(new Error(langdata.Enteravalidname ? langdata.Enteravalidname : 'Enter a valid name'));

    const validateEmail = (_, value) =>
        value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
            ? Promise.resolve()
            : Promise.reject(new Error(langdata.Enteravalidemailaddress ? langdata.Enteravalidemailaddress : 'Enter a valid email address'));

    const validatePhone = (_, value) =>
        value && /^[0-9+()\s-]*$/.test(value)
            ? Promise.resolve()
            : Promise.reject(new Error(langdata.Enteravalidphonenumber ? langdata.Enteravalidphonenumber : 'Enter a valid phone number'));

    return (
        <Content style={{ display: 'flex', justifyContent: 'center' }}>
            <Col
                xs={24}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                }}
            >
                <div
                    style={{
                        height: '100%',
                        width: '50%',
                        objectFit: 'contain',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <img style={{ height: '100%', width: '50%' }} src={banner} alt="Banner" />
                </div>
                <Card
                    style={{
                        width: '70%',
                        borderRadius: '8px',
                        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.18)',
                        borderTop: 'none',
                        margin: '10px',
                    }}
                >
                    <Row style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div style={{ fontWeight: 700, color: '#1965a4', fontSize: '36px' }}>
                            <HeaderText text = {langdata.DeleteAccount ? langdata.DeleteAccount : 'Delete Account'} color = '#1965a4' />
                        </div>
                        <p
                            style={{
                                // fontWeight: 500,
                                color: '#000000',
                                fontSize: '20px',
                                marginTop: '15px',
                                width: '70%',
                                textAlign: 'center',
                            }}
                        >
                            <BodyTextHeadingSmall text = {langdata.Deletingnotes ? langdata.Deletingnotes : 'Deleting your account will permanently erase your health data, including activity logs, measurements, and medical notes.' }/>
                        </p>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={handleSubmit}
                            style={{ width: '70%' }}
                            onValuesChange={(changedValues, allValues) => setFormValues(allValues)}
                        >
                            <Form.Item
                                label={<h3>{langdata.Firstname ? langdata.Firstname : 'First name' } <span style={{ color: 'red' }}>*</span></h3>}
                                name="firstName"
                                rules={[{ validator: validateAlpha }]}
                            >
                                <Input className='reduce-form-label' size="large" placeholder={langdata.Firstname ? langdata.Firstname : 'First name'} />
                            </Form.Item>
                            {fieldError.fieldFirstName && <p style={{ fontSize: '12px', color: 'red' }}>{langdata.Pleasefillyourfirstname ? langdata.Pleasefillyourfirstname : 'Please fill your first name' }</p>}

                            <Form.Item
                                label={<h3>{langdata.Lastname ? langdata.Lastname : 'Last name' }</h3>}
                                name="lastName"
                                // rules={[{ validator: validateAlpha }]}
                            >
                                <Input size="large" className='reduce-form-label'  placeholder={langdata.Lastname ? langdata.Lastname : 'Last name'} />
                            </Form.Item>

                            <Form.Item
                                label={<h3>{langdata.Email ? langdata.Email : 'E-mail' } <span style={{ color: 'red' }}>*</span></h3>}
                                name="email"
                                rules={[{ validator: validateEmail }]}
                            >
                                <Input size="large" className='reduce-form-label'  placeholder={langdata.Email ? langdata.Email : 'Email'} />
                            </Form.Item>
                            {fieldError.fieldEmail && <p style={{ fontSize: '12px', color: 'red' }}>{langdata.PleasefillyourEmail ? langdata.PleasefillyourEmail : 'Please fill your E-mail'}</p>}

                            <Form.Item
                                label={<h3>{langdata.Phonenumber ? langdata.Phonenumber : 'Phone number' } <span style={{ color: 'red' }}>*</span></h3>}
                                name="phoneNumber"
                                rules={[{ validator: validatePhone }]}
                            >
                                <Input size="large" className='reduce-form-label'  placeholder={langdata.Phonenumber ? langdata.Phonenumber : 'Phone number'} />
                            </Form.Item>
                            {fieldError.fieldPhone && <p style={{ fontSize: '12px', color: 'red' }}>{langdata.Pleasefillyourphonenumber ? langdata.Pleasefillyourphonenumber : 'Please fill your phone number' }</p>}

                            <Form.Item
                                label={<h3>{langdata.HelpusimproveWhyareyoudeletingyouraccount ? langdata.HelpusimproveWhyareyoudeletingyouraccount : 'Help us improve! Why are you deleting your account?' }</h3>}
                                name="feedback"
                            >
                                <TextArea size="large" className='reduce-form-label'  placeholder={langdata.Feedback ? langdata.Feedback : 'Feedback'} style={{ height: 120 }} />
                            </Form.Item>

                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                <Button type="primary" htmlType="submit" size="large" style={{ fontFamily: 'Roboto', fontSize: 'large' }}>
                                    <ButtonText text = {langdata.Submit ? langdata.Submit : 'Submit' }/>
                                </Button>
                            </div>
                            {err && (
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
                                    <h5 style={{ color: 'red' }}>{langdata.Pleasefillalltherequiredfields ? langdata.Pleasefillalltherequiredfields : 'Please fill all the required fields' }</h5>
                                </div>
                            )}
                        </Form>
                    </Row>
                </Card>
            </Col>
            <CustomSpin spinning = {requesting} />
        </Content>
    );
};

export default DeleteAccount;
